var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page bg-white" },
    [
      _c("vxe-toolbar", {
        attrs: {
          refresh: { query: _vm.refreshList },
          export: "",
          print: "",
          custom: "",
        },
        scopedSlots: _vm._u([
          {
            key: "buttons",
            fn: function () {
              return [
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      size: "small",
                      icon: "el-icon-plus",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.add()
                      },
                    },
                  },
                  [_vm._v("新建")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "div",
        { staticStyle: { height: "calc(100% - 40px)" } },
        [
          _c(
            "vxe-table",
            {
              ref: "reportsTable",
              attrs: {
                border: "inner",
                "auto-resize": "",
                resizable: "",
                height: "auto",
                loading: _vm.loading,
                size: "small",
                "show-header-overflow": "",
                "show-overflow": "",
                "highlight-hover-row": "",
                "menu-config": {},
                "print-config": {},
                "import-config": {},
                "export-config": {},
                data: _vm.dataList,
                "checkbox-config": {},
              },
            },
            [
              _c("vxe-column", { attrs: { type: "seq", width: "40" } }),
              _c("vxe-column", {
                attrs: { title: "报表名", field: "name", sortable: "" },
              }),
              _c("vxe-column", {
                attrs: { title: "更新日期", field: "updateDate", sortable: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm
                                .moment(scope.row.updateDate)
                                .format("YYYY-MM-DD HH:mm:ss")
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-column", {
                attrs: {
                  title: "操作",
                  width: "200px",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.pre(scope.row)
                              },
                            },
                          },
                          [_vm._v("预览")]
                        ),
                        _c("el-divider", { attrs: { direction: "vertical" } }),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.design(scope.row)
                              },
                            },
                          },
                          [_vm._v("设计")]
                        ),
                        _c("el-divider", { attrs: { direction: "vertical" } }),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.del(scope.row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                        _c("el-divider", { attrs: { direction: "vertical" } }),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.createMenu(scope.row)
                              },
                            },
                          },
                          [_vm._v("发布")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("gen-menu-form", { ref: "genMenuForm" }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }